import type { MessageDto } from "@multi-chat/shared";
import { isOutboundMessage } from "./inbox-display.js";

export type UnreadSeparator =
  | { kind: "none" }
  /** Before the oldest unread inbound message that is loaded. */
  | { kind: "before"; messageId: string }
  /** More unread messages than are loaded: pinned above the loaded history with a count. */
  | { kind: "pinned"; count: number };

/**
 * Where the "New messages" separator sits for the unread count captured when the thread opened.
 * Unread messages are the newest `unreadCount` inbound messages; outbound messages never count.
 */
export function unreadSeparatorAnchor(
  messages: readonly MessageDto[],
  unreadCount: number,
): UnreadSeparator {
  if (!Number.isFinite(unreadCount) || unreadCount <= 0) return { kind: "none" };
  const count = Math.trunc(unreadCount);
  const inbound = messages.filter((message) => !isOutboundMessage(message));
  if (inbound.length === 0) return { kind: "none" };
  if (count > inbound.length) return { kind: "pinned", count };
  return { kind: "before", messageId: inbound[inbound.length - count]!.messageId };
}
